import { render } from "./ClockpickerPlate.vue?vue&type=template&id=67b02048"
import script from "./ClockpickerPlate.vue?vue&type=script&lang=js"
export * from "./ClockpickerPlate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/mdbvue/pro/Forms/TimePicker/ClockpickerPlate.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "67b02048"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('67b02048', __exports__)) {
    api.reload('67b02048', __exports__)
  }
  
  module.hot.accept("./ClockpickerPlate.vue?vue&type=template&id=67b02048", () => {
    api.rerender('67b02048', render)
  })

}


export default __exports__